addEventListener("DOMContentLoaded", (event) => {

  var geoSpecificBadge = document.querySelectorAll(".geo-specific-badge");
  geoSpecificBadge.forEach((geoBadge) => {
    geoBadge.style.display = "none";
  })

  var geoSpecificAnnouncementBar = document.querySelectorAll(".geo-specific-announcement-bar");
  geoSpecificAnnouncementBar.forEach((geoAnnouncementBar) => {
    geoAnnouncementBar.style.display = "none";
  })

  var geoSpecificBlocks = document.querySelectorAll(".geo-specific-block");
  geoSpecificBlocks.forEach((geoBlock) => {
    geoBlock.style.display = "none";
  })

  var announementSelectedCountry = ["AU", "US", "CA", "GB"];

  // function to get the user's location
  getUserCountry();

  // Country lookup. Previously this asked api.country.is, a third-party domain
  // that is on the EasyPrivacy tracker blocklist, so every visitor with a
  // tracker blocker (NordVPN Threat Protection, AdGuard, uBlock, Brave, most
  // iOS content blockers) never got a country and never saw any geo element.
  // Now the store's own domain is asked first (Shopify's IP detection, then
  // Cloudflare's), which blockers cannot touch. The old service stays as a
  // last resort. The result is remembered for the session so later pages do
  // not repeat the request.
  function getUserCountry() {
    var cached = null;
    try { cached = sessionStorage.getItem("geoCountryCode"); } catch (e) {}
    if (cached) { applyCountry(cached); return; }

    fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', { credentials: 'same-origin' })
      .then(response => response.json())
      .then(data => {
        var code = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (!code) throw new Error('no country');
        return code;
      })
      .catch(() => fetch('/cdn-cgi/trace')
        .then(response => response.text())
        .then(text => {
          var m = text.match(/^loc=([A-Z]{2})$/m);
          if (!m) throw new Error('no loc');
          return m[1];
        })
      )
      .catch(() => fetch('https://api.country.is/', { method: 'GET' })
        .then(response => response.json())
        .then(response => response.country)
      )
      .then(code => {
        try { sessionStorage.setItem("geoCountryCode", code); } catch (e) {}
        applyCountry(code);
      })
      .catch(error => {
        console.error('Error: ' + error);
      })
  }

  function applyCountry(country_code) {
    isCountry = true;
    if (isCountry) {

      // product badge
      document.querySelectorAll('.geo-specific-badge[data-country="' + country_code + '"]').forEach((geoBadgeActive) => {
        geoBadgeActive.style.display = "block";
      })
      // product badge

      if(country_code == "AU"){
        document.querySelectorAll('[href="/products/ppl2"]').forEach((ppl_link)=>{
          ppl_link.style.display = 'none';
        })
      }

      // announcement bar
      if (announementSelectedCountry.indexOf(country_code) != -1) {
        announementSelectedCountry.forEach((selected_country) => {
          if (selected_country == country_code) {
            document.querySelectorAll('.geo-specific-announcement-bar[data-country="' + country_code + '"]').forEach((geoAnnounementActive) => {
              geoAnnounementActive.style.display = "block";
            })
          }
        })
      } else {
        if (document.querySelectorAll('.geo-specific-announcement-bar[data-country="global"]')) {
          document.querySelectorAll('.geo-specific-announcement-bar[data-country="global"]').forEach((geoAnnounementActive) => {
            geoAnnounementActive.style.display = "block";
          })
        }
      }

      // announcement bar

      // geo block
      if (announementSelectedCountry.indexOf(country_code) != -1) {
        announementSelectedCountry.forEach((selected_country) => {
          if (selected_country == country_code) {
            document.querySelectorAll('.geo-specific-block[data-country="' + country_code + '"]').forEach((geoBlock) => {
              geoBlock.style.display = "block";
            })
          }
        })
      } else {
        if (document.querySelectorAll('.geo-specific-block[data-country="global"]')) {
          document.querySelectorAll('.geo-specific-block[data-country="global"]').forEach((geoBlock) => {
            geoBlock.style.display = "block";
          })
        }
      }

      // geo block
    }
  }

});